import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import Column from '../layout/Column';
import Typography from '../typography/Typography';
const WidgetErrorFallback = ({ message = 'Unable to display this content', ...columnProps }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    return (React.createElement(Column, { ph: theme.spacing.page, pv: theme.spacing.standard.sm, ...columnProps },
        React.createElement(Typography, { color: theme.palette.typography.secondary }, message)));
};
const stylesGenerator = createThemedStyle(() => ({}));
export default WidgetErrorFallback;
